var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg321C9B5A707885092Ab66Bbeb813697B15E373Cf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 22.5 46.5001",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.78576 0.541713C1.72924 -0.266986 3.14967 -0.157723 3.95837 0.78576L21.9584 21.7858C22.6806 22.6284 22.6806 23.8717 21.9584 24.7143L3.95837 45.7143C3.14967 46.6578 1.72924 46.7671 0.78576 45.9584C-0.157723 45.1497 -0.266986 43.7292 0.541713 42.7858L17.2866 23.25L0.541713 3.71432C-0.266986 2.77084 -0.157723 1.35041 0.78576 0.541713Z",
    fill: "var(--fill-0, white)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg321C9B5A707885092Ab66Bbeb813697B15E373Cf);
export default __webpack_public_path__ + "static/media/321c9b5a707885092ab66bbeb813697b15e373cf.8c42c3524ce3de7838508cff01362be5.svg";
export { ForwardRef as ReactComponent };